import React, { useState } from "react";
import Icon from "../../../components/AppIcon";
import Button from "../../../components/ui/Button";
import Select from "../../../components/ui/Select";
import OrderStatusBadge from "./OrderStatusBadge";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import {
  assignOrderService,
  getOrdersService,
} from "redux/services/orders_service";
import { toast } from "react-toastify";

const OrderDetailsModal = ({ order, onClose }) => {
  const dispatch = useDispatch();

  const { t, i18n } = useTranslation();

  const [activeTab, setActiveTab] = useState("details");
  const [newStatus, setNewStatus] = useState(order.status);

  const statusOptions = [
    { value: 1, label: t("not_confirmed") }, // CREATED

    { value: 2, label: t("processing") }, // PREPARED

    { value: 3, label: t("shipped") }, // ON_DELIVERY

    { value: 4, label: t("delivered") }, // DELIVERED

    { value: 5, label: t("completed") }, // COMPLETED

    { value: 6, label: t("cancelled") }, // CANCELLED
  ];

  const handleStatusUpdate = async () => {
    try {
      await dispatch(
        assignOrderService({ id: order.id, data: { order_status: newStatus } })
      ).then((response) => {
        if (response?.payload) {
          toast("تم تغيير الحالة بنجاح");
          onClose();
          dispatch(getOrdersService());
          //  window.location.reload();
        }
      });
    } catch (error) {
      console.error("Error updating status:", error);

      // Optionally, show an error message to the user
    }
  };
  const tabs = [
    { id: "details", label: t("orderDetails"), icon: "FileText" },
    { id: "items", label: t("orderItems"), icon: "Package" },
    { id: "shipping", label: t("shippingAddress"), icon: "Truck" },
    { id: "payment", label: t("paymentDetails"), icon: "CreditCard" },
  ];

  const formatPrice = (price) => {
    return new Intl.NumberFormat(i18n.language === "en" ? "en" : "ar", {
      style: "currency",
      currency: "IQD",
      maximumFractionDigits: 0,
    }).format(price);
  };

  const formatDate = (date) => {
    return new Date(date).toLocaleString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  /*const handleStatusUpdate = () => {
    console.log("Updating status to:", newStatus);
   
  };*/

  const renderTabContent = () => {
    switch (activeTab) {
      case "details":
        return (
          <div className="space-y-8">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              {/* Left column */}
              <div className="space-y-6">
                <div>
                  <label className="block text-sm font-semibold text-gray-500">
                    {t("orderNumber")}
                  </label>
                  <div className="font-mono text-xl font-bold text-gray-900">
                    #{order?.id}
                  </div>
                </div>
                <div>
                  <label className="block text-sm font-semibold text-gray-500">
                    {t("order_date")}
                  </label>
                  <div className="text-gray-700">
                    {formatDate(order?.created_at)}
                  </div>
                </div>
                <div>
                  <label className="block text-sm font-semibold text-gray-500">
                    {t("status")}
                  </label>
                  <div className="mt-2">
                    <OrderStatusBadge status={order?.order_status_name} />
                  </div>
                </div>

                <div>
                  <label className="block text-sm font-semibold text-gray-500">
                    رقم الهاتف
                  </label>
                  <div className="text-gray-700">
                    {" "}
                    {order?.customer?.phone_number}
                  </div>
                </div>

                {order?.order_status == 4 && (
                  <div>
                    <label className="block text-sm font-semibold text-gray-500">
                      تاريخ التوصيل
                    </label>
                    <div className="text-gray-700">
                      {" "}
                      {formatDate(order?.delivery_date)}
                    </div>
                  </div>
                )}
              </div>

              {/* Right column */}
              <div className="space-y-6">
                <div>
                  <label className="block text-sm font-semibold text-gray-500">
                    {t("customer")}
                  </label>
                  <div className="text-gray-900 font-semibold">
                    {order?.customer?.first_name} {order?.customer?.last_name}
                  </div>
                  <div className="text-sm text-gray-500">
                    {order?.customer?.email}
                  </div>
                </div>
                <div>
                  <label className="block text-sm font-semibold text-gray-500">
                    {t("total")}
                  </label>
                  <div className="text-2xl font-extrabold text-gray-900">
                    {formatPrice(order?.total_amount)}
                  </div>
                </div>
                <div>
                  <label className="block text-sm font-semibold text-gray-500">
                    {t("paymentDetails")}
                  </label>
                  <div className="text-gray-700">كاش عند الاستلام</div>
                </div>

                {order?.order_status == 4 && (
                  <div>
                    <label className="block text-sm font-semibold text-gray-500">
                      المبلغ المستلم
                    </label>
                    <div className="text-gray-700">
                      {" "}
                      {order?.payment?.payment_amount}
                    </div>
                  </div>
                )}
              </div>
            </div>

            {/* Update status */}
            <div className="border-t border-gray-200 pt-6 flex flex-col md:flex-row md:items-center md:space-x-6 space-y-4 md:space-y-0">
              <div className="flex-1 max-w-xs">
                <Select
                  label={"تحديث الحالة"}
                  options={statusOptions}
                  value={newStatus}
                  onChange={setNewStatus}
                />
              </div>
              <Button
                variant="primary"
                onClick={handleStatusUpdate}
                disabled={newStatus === order.status}
                className="w-full md:w-auto"
              >
                {t("updateStatus")}
              </Button>
            </div>
          </div>
        );

      case "items":
        return (
          <div className="space-y-6">
            <h4 className="text-lg font-semibold text-gray-900">
              {t("orderItems")} ({order?.items?.length})
            </h4>
            <div className="space-y-4 max-h-[50vh] overflow-y-auto pr-2">
              {order?.items?.map((item, index) => (
                <div
                  key={index}
                  className="flex items-center space-x-4 p-4 bg-gray-50 rounded-lg shadow-sm"
                >
                  <div className="w-14 h-14 bg-primary/20 rounded-md flex items-center justify-center">
                    <Icon name="Package" size={24} className="text-primary" />
                  </div>
                  <div className="flex-1">
                    <div className="font-semibold text-gray-900">
                      {item?.product?.name}
                    </div>
                    <div className="text-sm text-gray-500">
                      {t("quantity_label")}: {item?.quantity}
                    </div>
                  </div>
                  {/*<div className="text-right min-w-[80px]">
                   
                    <div className="font-semibold text-gray-900">{formatPrice(item.price)}</div>
                  </div>*/}
                  <div className="text-right min-w-[100px] font-bold text-gray-900">
                    {formatPrice(item?.product?.price * item?.quantity)}
                  </div>
                </div>
              ))}
            </div>
          </div>
        );

      case "shipping":
        return (
          <div className="space-y-8">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              <div>
                <h4 className="flex items-center space-x-2 text-lg font-semibold text-gray-900 mb-4">
                  <Icon name="MapPin" size={18} className="text-primary" />
                  <span>{t("shippingAddress")}</span>
                </h4>
                <div className="space-y-1 text-gray-700 text-sm">
                  <div className="font-semibold">
                    {order?.first_name} {order?.last_name}
                  </div>
                  <div>{order?.address}</div>
                  <div>{order?.area?.name}</div>

                  <div>
                    {" "}
                    <a
                      href={order?.customer?.location_link}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ color: "blue" }}
                    >
                      {order?.customer?.location_link}
                    </a>
                  </div>
                </div>
              </div>

              {/*   <div>
                <h4 className="flex items-center space-x-2 text-lg font-semibold text-gray-900 mb-4">
                  <Icon name="Truck" size={18} className="text-primary" />
                  <span>{t('shippingDetails')}</span>
                </h4>
                <div className="space-y-3 text-sm text-gray-700">
                  <div className="flex justify-between">
                    <span className="font-medium text-gray-500">{t('method')}:</span>
                    <span>Standard Shipping</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="font-medium text-gray-500">{t('cost')}:</span>
                    <span>{formatPrice(order.shipping_price)}</span>
                  </div>
                </div>
              </div>*/}
            </div>
          </div>
        );

      case "payment":
        return order?.payment !== null ? (
          <div className="space-y-8">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              <div>
                <h4 className="flex items-center space-x-2 text-lg font-semibold text-gray-900 mb-4">
                  <Icon name="CreditCard" size={18} className="text-primary" />
                  <span>{t("paymentDetails")}</span>
                </h4>
                <div className="space-y-3 text-sm text-gray-700">
                  <div className="flex justify-between">
                    <span className="font-medium text-gray-500">
                      {t("method")}:
                    </span>
                    <span>كاش</span>
                  </div>
                  {/*<div className="flex justify-between">
                    <span className="font-medium text-gray-500">
                      {t("status")}:
                    </span>
                    <span>{order?.payment?.total_amount}</span>
                  </div>*/}
                  <div className="flex justify-between">
                    <span className="font-medium text-gray-500">
                      {t("amount")}:
                    </span>
                    <span className="font-semibold">
                      {order?.payment?.payment_amount}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div>لا يوجد معلومات دفع لأنه لم يتم توصيل الطلب بعد</div>
        );

      default:
        return null;
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-60 z-50 flex items-center justify-center p-6">
      <div className="bg-white rounded-xl shadow-lg w-1/2 max-w-2xl max-h-[90vh] flex flex-col overflow-hidden">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-gray-200">
          <div className="flex items-center space-x-4">
            <Icon name="FileText" size={28} className="text-primary" />
            <div>
              <h2 className="text-2xl font-bold text-gray-900">
                {t("orderDetails")}
              </h2>
              <p className="text-sm text-gray-500">#{order?.id}</p>
            </div>
          </div>
          <button
            onClick={onClose}
            aria-label="Close modal"
            className="text-gray-400 hover:text-gray-700 transition"
          >
            <Icon name="X" size={24} />
          </button>
        </div>

        {/* Tabs */}
        <nav className="flex border-b border-gray-200 px-6">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`flex items-center space-x-2 py-4 px-3 border-b-4 transition-colors duration-200 ${
                activeTab === tab.id
                  ? "border-green-600 text-green-700 font-semibold"
                  : "border-transparent text-gray-500 hover:text-gray-700"
              }`}
            >
              <Icon name={tab.icon} size={18} />
              <span className="text-sm">{tab.label}</span>
            </button>
          ))}
        </nav>

        {/* Content */}
        <div className="p-6 overflow-y-auto flex-1">{renderTabContent()}</div>

        {/* Footer */}
        <div className="flex items-center justify-end space-x-4 p-6 border-t border-gray-200 bg-gray-50">
          <Button variant="outline" onClick={onClose}>
            {t("close")}
          </Button>
          {/* <Button
            variant="primary"
            onClick={() => console.log('Print order:', order.id)}
            iconName="Printer"
            iconPosition="left"
          >
            {t('printOrder')}
          </Button>*/}
        </div>
      </div>
    </div>
  );
};

export default OrderDetailsModal;
